import './Header.css';
export const Header = () =>{
    return(
        <header className='header' >
            <h1 className='header__title'>Lista de tarefas</h1>
        </header>
    );
}


